export function formatCpfCnpj (value) {
  const cnpjCpf = value.replace(/\D/g, '')

  if (cnpjCpf.length === 11) {
    return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '***.$2.$3-**')
  }

  return cnpjCpf.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
    '**.$2.$3/$4-**'
  )
}

export function formatCpf (value) {
  const cpf = value.replace(/\D/g, '')
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export function formatCnpj (value) {
  const cnpj = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()

  if (cnpj.length !== 14) {
    return value
  }

  return cnpj.replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})$/,
    '$1.$2.$3/$4-$5'
  )
}

export function isAlphanumericCnpj (value) {
  if (!value) return false
  const cnpj = String(value).replace(/[^a-zA-Z0-9]/g, '')
  if (cnpj.length !== 14) return false
  return /[a-zA-Z]/.test(cnpj)
}

export function unformatCnpj (value) {
  return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
}

export function unformatCpf (value) {
  return value.replace(/\D/g, '')
}

export function formatNumberToCpfCnpj (value) {
  const cnpjCpf = value.replace(/[^a-zA-Z0-9]/g, '')

  if (cnpjCpf.length === 11 && /^\d+$/.test(cnpjCpf)) {
    return formatCpf(cnpjCpf)
  }

  if (cnpjCpf.length === 14) {
    return formatCnpj(cnpjCpf)
  }

  return value
}

export function isCpfValid (cpf) {
  let temp = cpf
  if (typeof temp !== 'string') return false

  temp = temp.replace(/[^\d]+/g, '')

  if (temp.length !== 11 || !!temp.match(/(\d)\1{10}/)) return false

  temp = temp.split('')

  const validator = temp
    .filter((digit, index, array) => index >= array.length - 2 && digit)
    .map(el => +el)

  const toValidate = pop =>
    temp
      .filter((digit, index, array) => index < array.length - pop && digit)
      .map(el => +el)

  const rest = (count, pop) =>
    ((toValidate(pop).reduce((soma, el, i) => soma + el * (count - i), 0) *
      10) %
      11) %
    10

  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])
}

export function isCnpjValid (string) {
  const regexCNPJFormatted =
    /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/i
  const regexCNPJLegacy = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/

  function charToNumber (char) {
    return char.toUpperCase().charCodeAt(0) - 48
  }

  function matchAlphanumeric (value) {
    const match = value
      .toString()
      .toUpperCase()
      .match(/[A-Z0-9]/g)
    return Array.isArray(match) ? match : []
  }

  function validCalcLegacy (position, numbers) {
    const slice = numbers.slice(0, position)
    let factor = position - 7
    let sum = 0

    for (let i = position; i >= 1; i--) {
      const n = slice[position - i]
      sum += n * factor--
      if (factor < 2) factor = 9
    }

    const result = 11 - (sum % 11)
    return result > 9 ? 0 : result
  }

  function validCalcAlphanumeric (position, chars) {
    const slice = chars.slice(0, position)
    let factor = position - 7
    let sum = 0

    for (let i = position; i >= 1; i--) {
      const char = slice[position - i]
      const n = charToNumber(char)
      sum += n * factor--
      if (factor < 2) factor = 9
    }

    const result = 11 - (sum % 11)
    return result > 9 ? 0 : result
  }

  if (!string) return false

  const isString = typeof string === 'string'
  const validTypes =
    isString || Number.isInteger(string) || Array.isArray(string)

  if (!validTypes) return false

  if (isString) {
    const unformatted = string.replace(/[^a-zA-Z0-9]/g, '')
    const digitsOnly = /^[0-9]{14}$/.test(unformatted)
    const alphanumeric = /^[A-Z0-9]{12}\d{2}$/i.test(unformatted)
    const validFormatLegacy = regexCNPJLegacy.test(string)
    const validFormatNew = regexCNPJFormatted.test(string)
    const isValid =
      digitsOnly || alphanumeric || validFormatLegacy || validFormatNew

    if (!isValid) return false
  }

  const chars = matchAlphanumeric(string)

  if (chars.length !== 14) return false

  const items = [...new Set(chars)]
  if (items.length === 1) return false

  const digits = chars.slice(12)
  const hasLetters = isAlphanumericCnpj(string)

  if (hasLetters) {
    const digit0 = validCalcAlphanumeric(12, chars)
    if (digit0 !== parseInt(digits[0], 10)) return false

    const digit1 = validCalcAlphanumeric(13, chars)
    return digit1 === parseInt(digits[1], 10)
  } else {
    const numbers = chars.map(Number)
    const numericDigits = numbers.slice(12)

    const digit0 = validCalcLegacy(12, numbers)
    if (digit0 !== numericDigits[0]) return false

    const digit1 = validCalcLegacy(13, numbers)
    return digit1 === numericDigits[1]
  }
}
